import Vue from 'vue'
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'
import lang from '@/lang'

// videojs 지원 언어 자동 생성을 위해 추가
const langList = Object.keys(lang)
for (const index in langList) {
  videojs.addLanguage(langList[index], lang[langList[index]])
}

Vue.prototype.$video = videojs
